import React, { Component } from 'react';
import { Container, Menu, Loader } from 'semantic-ui-react';
import EscaypeFogMap from './EscaypeFogMap';
import Client from '../Client';
import GeocodeSearch from './GeocodeSearch';
import minBy from 'lodash.minby';
import location from '../location';
import '../styles/HeatMapContainer.css';

class FogMapContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeItem: 'current',
      heatMapData: {
        current: null,
        next: null,
        extended: null
      },
      markerInfoWindowData: {
        current: null,
        next: null,
        extended: null
      }
    };
  }

  componentDidMount() {
    Promise.all([
      Client.getHeatmapData_v4(1),
      Client.getHeatmapData_v4(2),
      Client.getHeatmapData_v4(3)
    ]).then(response => {
      console.log(response); // eslint-disable-line no-console
      this.setState({
        heatMapData: {
          current: response[0],
          next: response[1],
          extended: response[2]
        }
      });

      location.getLocation()
        .then(position => {
          this.handleMarkerPositionChanged(position);
        });

    }).catch(e => {
      console.log('Error loading fog map data:', e); // eslint-disable-line no-console
    });
  }

  handleItemClick = (e, { name }) => {
    this.setState({ activeItem: name });
  }

  handleMarkerPositionChanged = position => {
    this.setState({
      markerInfoWindowData: {
        current: null,
        next: null,
        extended: null
      }
    });

    this.setState({
      markerInfoWindowData: {
        current: this.findNearestFogHeight(position, this.state.heatMapData.current),
        next: this.findNearestFogHeight(position, this.state.heatMapData.next),
        extended: this.findNearestFogHeight(position, this.state.heatMapData.extended)
      }
    });
  };

  findNearestFogHeight = (position, heatMapData) => {
    function getDistance( x1, y1, x2, y2 ) {
      var   xs = x2 - x1,
            ys = y2 - y1;

      xs *= xs;
      ys *= ys;

      return Math.sqrt( xs + ys );
    }

    return minBy(heatMapData, o => getDistance(position.lat, position.lng, o.obsLats, o.obsLons))
  }

  render() {
    const { activeItem } = this.state;
    const heatMapData = this.state.heatMapData[activeItem];
    const markerInfoWindowData = this.state.markerInfoWindowData[activeItem];

    const heatMap = this.state.heatMapData[activeItem] ?
      <EscaypeFogMap heatMapData={heatMapData} 
        markerInfoWindowData={markerInfoWindowData} 
        onMarkerPositionChanged={this.handleMarkerPositionChanged} /> :
      <Loader active inline='centered' size='huge'>Loading</Loader>;

    return (
      <div className='heat-map-container'>
        <Container text style={{marginBottom: '1rem'}}>
          <GeocodeSearch onPositionChanged={this.handleMarkerPositionChanged} />
          <Menu pointing secondary fluid widths={3} style={{flexDirection: 'row', borderRadius: 0}}>
            <Menu.Item name='current' active={activeItem === 'current'} onClick={this.handleItemClick} />
            <Menu.Item name='next' active={activeItem === 'next'} onClick={this.handleItemClick} />
            <Menu.Item name='extended' active={activeItem === 'extended'} onClick={this.handleItemClick} />
          </Menu>
        </Container>
        {heatMap}
      </div>
    );
  }
}

export default FogMapContainer;